module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS11.77a0d481.jpg";